
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {ApplicationState} from "@/api-client";
    import translateApplicationState from "@/features/applications/components/ApplicationStateTranslator";

    @Component
    export default class ApplicationStateBadge extends Vue {
        @Prop({required: true})
        state!: ApplicationState

        get text(): string {
            return translateApplicationState(this.state);
        }
        
        get badgeClass() {
            return { 'badge badge-secondary': this.state === ApplicationState.ApplicationNotSubmitted,
                'badge badge-warning': this.state === ApplicationState.ApplicationSubmitted,
                'badge badge-primary': this.state === ApplicationState.PendingApplication,
                'badge badge-danger': this.state === ApplicationState.ApplicationRejected,
                'badge badge-success': this.state === ApplicationState.DocumentIssued };
        }
    }
